import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';
import RegisterImg from 'assets/register.svg';
import OurPartners from '../components/OurPartners';

export const Company = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      <div className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white text-center">
        <h1 className="text-4xl md:text-7xl font-black mb-4">Wire24</h1>
        <p className="text-lg md:text-xl font-light">
          Empowering secure and seamless money transfers globally.
        </p>
      </div>

      <section className=" pt-39 pb-17.5">
        <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
          <div className="flex flex-col lg:flex-row items-center gap-7.5 xl:gap-14">
            <div className="lg:max-w-[570px] w-full">
              <img
                src={RegisterImg}
                alt="about"
                className="mx-auto md:mx-0 w-[60vw] md:w-full md:-mt-48 md:-ml-24"
              />
            </div>

            <div className="lg:max-w-[490px] w-full">
              <span className="inline-flex text-primary font-semibold text-4xl mb-2.5">
                Who we are
              </span>
              <h1 className="font-bold text-heading-6 sm:text-heading-4 lg:text-heading-3 text-dark mb-5">
                Revolutionizing Digital Remittance
              </h1>
              <p>
                Wire24 is a cutting-edge digital remittance platform dedicated to making money
                transfers secure, fast, and cost-effective. With a focus on financial inclusion, we
                help individuals and businesses move money across borders seamlessly.
              </p>
              <p className="mt-4.5">
                Our technology-driven solutions ensure competitive exchange rates, minimal
                transaction fees, and top-tier security. Whether you’re sending money to family or
                supporting global business operations, Wire24 is your trusted partner in digital
                finance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="pb-15">
        <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
          <div className="flex flex-wrap items-center justify-between gap-8 mb-6">
            <div className="">
              <h2 className="font-semibold text-4xl text-heading-5 text-dark">Our Team</h2>
              <h2 className="font-semibold text-heading-5 text-dark">
                The team that makes it possible.
              </h2>
            </div>
          </div>
          <div className="font-bold text-xl mb-4">Directors</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-11 gap-8 gap-x-7.5">
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-01.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Zac</h4>
                  <p>Director of Operations</p>
                </div>
              </div>
            </div>
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-02.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Shaliff Kyazuzo</h4>
                  <p>Content writer</p>
                </div>
              </div>
            </div>
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-03.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Talan Philips</h4>
                  <p>Director of Operations</p>
                </div>
              </div>
            </div>
          </div>

          <div className="font-bold text-xl mb-4 mt-12">Technical Team</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-11 gap-8 gap-x-7.5">
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-01.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Jonathan Mwebaze</h4>
                  <p>Director of Operations</p>
                </div>
              </div>
            </div>
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-02.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Seth Ochieng</h4>
                  <p>Content writer</p>
                </div>
              </div>
            </div>
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-03.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Emmanuel Lubwama</h4>
                  <p>Director of Operations</p>
                </div>
              </div>
            </div>
            <div className="border border-gray-3 rounded-[20px] bg-gray p-5 transition-all">
              <div className="flex flex-wrap items-center gap-8">
                <div className="w-25 h-25 rounded-full overflow-hidden">
                  <img src="images/user-03.png" alt="user" />
                </div>
                <div>
                  <h4 className="font-semibold text-custom-xl text-dark mb-1">Isiko </h4>
                  <p>Director of Operations</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <OurPartners bend={3} textColor="#ffffff" borderRadius={0.05} /> */}
    </WebLayout>
  );
};
